import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Form, FormGroup, FormControl, Button, InputGroup, Glyphicon, HelpBlock } from 'react-bootstrap';

import { inject, bind } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';
import { ApiStore } from '../../stores/ApiStore';

@observer
export default class Login extends React.Component<RouteComponentProps<{}>, {}> {

  @inject(UiStore) private uiStore: UiStore;
  @inject(ApiStore) private apiStore: ApiStore;

  @observable loginUser: string = '';
  @observable loginPass: string = '';
  @observable loginError: boolean = false;
  @observable loginSuccess: boolean = false;
  @observable loginErrorText: string = '';

  @action setLoginSuccess() {
    this.loginSuccess = true;
  }

  @action setLoginError(loginErrorText: string) {
    this.loginError = true;
    this.loginPass = '';
    this.loginErrorText = loginErrorText;
  }

  @bind async handleLoginRequest(event: React.FormEvent<FormControl>) {
    event.preventDefault();
    const loginResponse = await this.uiStore.login(this.loginUser, this.loginPass);
    if (loginResponse.ok) {
      this.setLoginSuccess();
    } else {
      this.setLoginError(loginResponse.error);
    }
  }


  @bind @action handleUserNameChanged(event: React.FormEvent<FormControl>) {
    this.loginUser = (event.target as HTMLInputElement).value;
  }

  @bind @action handlePasswordChanged(event: React.FormEvent<FormControl>) {
    this.loginPass = (event.target as HTMLInputElement).value;
  }

  render() {
    const validationState = (this.loginError) ? 'error' : undefined;

    if (this.loginSuccess) {
      let from = { pathname: '/auftraege' } as Location;
      if (this.uiStore.currentLocation.state && this.uiStore.currentLocation.state.from) {
        from = this.uiStore.currentLocation.state.from;
      }
      return <Redirect to={from}/>;
    }

    return (
      <div>

        <Form horizontal={true} onSubmit={this.handleLoginRequest} className="login">

          <FormGroup validationState={validationState}>
            <h2>Login</h2>

            <InputGroup>
              <InputGroup.Addon><Glyphicon glyph="user" /></InputGroup.Addon>
              <FormControl
                type="text"
                placeholder="Benutzername"
                name="loginUser"
                value={this.loginUser}
                onChange={this.handleUserNameChanged}
              />
            </InputGroup>
          </FormGroup>

          <FormGroup validationState={validationState}>
            <InputGroup>
              <InputGroup.Addon><Glyphicon glyph="lock" /></InputGroup.Addon>
              <FormControl
                type="password"
                placeholder="Kennwort"
                name="loginPass"
                value={this.loginPass}
                onChange={this.handlePasswordChanged}
              />
            </InputGroup>
            {this.loginError && <HelpBlock className="login-helpblock">{this.loginErrorText}</HelpBlock>}
            {(this.apiStore.sessionMessage !== '') &&
              <HelpBlock className="login-helpblock">{this.apiStore.sessionMessage}</HelpBlock>
            }
          </FormGroup>

          <FormGroup>
            <Button bsStyle="primary" type="submit" block={true}>Anmelden</Button>
          </FormGroup>

        </Form>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/Login.tsx